import { colors } from 'ic-snacks'
import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { dashFontSizes } from 'legacy/dash-blocks/foundation/typography'

const HeaderWrapper = styled.div`
  padding: 16px 18px 14px;
  border-bottom: 1px solid ${colors.GRAY_93};
  display: flex;
  flex-flow: column nowrap;
`

const HeaderTitle = styled.span`
  font-size: ${dashFontSizes.LARGE};
  font-weight: 500;
`

export interface DashCardHeaderProps {
  header?: string
}

export const DashCardHeader: FunctionComponent<DashCardHeaderProps> = ({ header }) => {
  if (!header) return null

  return (
    <HeaderWrapper>
      <HeaderTitle>{header}</HeaderTitle>
    </HeaderWrapper>
  )
}
